export default __webpack_public_path__ + "static/media/update-app.29e2f160.svg";